export default __webpack_public_path__ + "static/cercle-shape-f14ae2238864a33e83e988e6d7e6235d.png";